import { Component } from '@angular/core';
import { SpinnerService } from 'components';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'UIL2';
  appLoading = false;

  constructor(private spinner: NgxSpinnerService, private spinnerService: SpinnerService) { }

  ngOnInit() {
    this.spinnerService.spinnerObservable.subscribe(show => {
      if (show)
        this.spinner.show()
      else
        this.spinner.hide()
    });
  }
}
